'use client'

function scopeStrapiStyles(html, scopeClass = '.strapi-content') {
  return html.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, css) => {
    const scopedCss = css.replace(/(^|\})([^{]+)/g, (m, p1, selectors) => {
      const scopedSelectors = selectors
        .split(',')
        .map((s) => {
          s = s.trim()
          if (s.startsWith('@')) return s
          if (!s) return ''
          return `${scopeClass} ${s}`
        })
        .join(', ')
      return `${p1}${scopedSelectors}`
    })
    return `<style>${scopedCss}</style>`
  })
}

export default function StrapiStaticHtml({ data }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: scopeStrapiStyles(data.html, `strapi-content-${data.id}`),
      }}
    />
  )
}
